import React, { useState, useEffect , useRef} from 'react';
import styled from "styled-components";


import { MainContainer } from "../../components/mainContainer";
// import quoteEnd from "../../assets/section-four-bubble.svg";

import mascott from "../../assets/get-comments-mascott-again-latest.png";
// import robotAssist from "../../assets/comments-two-robot.png";
import logodash from "../../assets/logodash.png";
import con1 from "../../assets/con1.png";
import { size } from "../../utils/helpers";
import Link from "../../components/link";
import topright from "../../assets/topright.png";
import topleft from "../../assets/topleft.png";
import bottomleft from "../../assets/bottomleft.png";
import bottomright from "../../assets/bottomright.png";
import dashlogo from "../../assets/dashlogo.png";
import dashlogo2 from "../../assets/dashlogo2.png";
import icon1 from "../../assets/icon1.svg";
import icon2 from "../../assets/icon2.svg";
import icon3 from "../../assets/icon3.svg";
import icon4 from "../../assets/icon4.svg";
import icon5 from "../../assets/icon5.svg";
import icon6 from "../../assets/icon6.svg";
import { MdPadding } from "react-icons/md";
import { fetchAPI } from "../../utils/fetch";
import { USER_SUBSCRIPTION, config, urlPaths } from "../../utils/config";
import { useLocation } from "react-router-dom";
import checkIcon from "../../assets/modal-check-icon.png";
import { Loader } from "../../components/loader";
import { useGetStoredData } from "../../hooks/useGetStoreData";





const DashboardComingSoon = () => {
  const [isToggleVisible, setIsToggleVisible] = useState(true);
  const [activeTab, setActiveTab] = useState("tab1");
 
  const [isPlanModalOpen, setPlanModalOpen] = useState(false);
  const storedData = useGetStoredData();
  const [stripeId, setStripeId] = useState("");
  const [status, setStatus] = useState("");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoadingPrm, setLoadingPrm] = useState(false);
  const [isLoadingPro, setLoadingPro] = useState(false);
  const [isLoadingThree, setLoadingThree] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [isCheckedCRM, setIsCheckedCRM] = useState(true);
  const [showProfessionalBanner, setShowProfessionalBanner] = useState(false);
  const [showProfessionalBannerYearly, setShowProfessionalBannerYearly] = useState(false);
  const userDetail = JSON.parse(localStorage.getItem("userData"));
  const storage = JSON.parse(localStorage.getItem("userData"));
  const [leadsData, setLeadsData] = useState([])
  const [logsData, setLogsData] = useState([])
  const debounceTimer = useRef(null);
  const openPlanModal = () => setPlanModalOpen(true);
  const closePlanModal = () => setPlanModalOpen(false);


   
  const handleClicklink = () => {
    window.open('https://chromewebstore.google.com/detail/social-post-mate-commente/ffebfjkgjgbpmnoogjjdgfkmiobngdnf', '_blank');
  };
  const  handleClicksupprt = () => {
    window.open('mailto:support@commenter.ai', );
  };
  const handleClicksetting = () => {
    window.open('/settings' ,  '_self');
  };
    const handleSubscribe = () => {
      setLoadingThree(true);
      fetchAPI
        .post(
          `${config.urlPlatform}/api/v2/payment/subscription`,
          {
            withCredentials: true,
          },
          {
            email: email,
            subscriptionId: stripeId,
            plan: "starter",
          }
        )
        .then((response) => {
          setLoadingThree(false);
          if (response.status !== 200) {
            throw new Error("error");
          }
          if (response.data.success === false) {
            setErrorMessage(response.data.message);
          } else {
            window.location.replace(response.data.url);
            setSuccessMessage("Successfully upgraded subscription!");
            localStorage.setItem("subscription", "pro");
          }
        })
        .catch((error) => {
          setLoadingThree(false);
          setErrorMessage("There was an issue subscribing. Please contact us!");
        });
    };
  
    const handleSubscribePrm = () => {
      console.log({
        email: email,
        subscriptionId: stripeId,
        plan: "proMonth",
      })
      setLoadingPrm(true);
      fetchAPI
        .post(
          `${config.urlPlatform}/api/v2/payment/subscription`,
          {
            withCredentials: true,
          },
          {
            email: email,
            subscriptionId: stripeId,
            plan: "proMonth",
          }
        )
        .then((response) => {
          setLoadingPrm(false);
          if (response.status !== 200) {
            throw new Error("error");
          }
          if (response.data.success === false) {
            setErrorMessage(response.data.message);
          } else {
            window.location.replace(response.data.url);
            setSuccessMessage("Successfully upgraded subscription!");
            localStorage.setItem("subscription", "pro");
          }
        })
        .catch((error) => {
          setLoadingPrm(false);
          setErrorMessage("There was an issue subscribing. Please contact us!");
        });
    };
  
    const handleSubscribePro = () => {
      setLoadingPro(true);
      fetchAPI
        .post(
          `${config.urlPlatform}/api/v2/payment/subscription`,
          {
            withCredentials: true,
          },
          {
            email: email,
            subscriptionId: stripeId,
            plan: "professional",
          }
        )
        .then((response) => {
          setLoadingPro(false);
          if (response.status !== 200) {
            throw new Error("error");
          }
          if (response.data.success === false) {
            setErrorMessage(response.data.message);
          } else {
            window.location.replace(response.data.url);
            setSuccessMessage("Successfully upgraded subscription!");
            localStorage.setItem("subscription", "pro");
          }
        })
        .catch((error) => {
          setLoadingPro(false);
          setErrorMessage("There was an issue subscribing. Please contact us!");
        });
    };
  const handleSubscribeYearly = () => {
     setLoadingThree(true);
     fetchAPI
       .post(
         `${config.urlPlatform}/api/v2/payment/subscription`,
         {
           withCredentials: true,
         },
         {
           email: email,
           subscriptionId: stripeId,
           plan: "starter_yearly",
         }
       )
       .then((response) => {
         setLoadingThree(false);
         if (response.status !== 200) {
           throw new Error("error");
         }
         if (response.data.success === false) {
           setErrorMessage(response.data.message);
         } else {
           window.location.replace(response.data.url);
           setSuccessMessage("Successfully upgraded subscription!");
           localStorage.setItem("subscription", "pro");
         }
       })
       .catch((error) => {
         setLoadingThree(false);
         setErrorMessage("There was an issue subscribing. Please contact us!");
       });
   };
 
   const handleSubscribeProfesYearly = () => {
     
     setLoadingPro(true);
     fetchAPI
       .post(
         `${config.urlPlatform}/api/v2/payment/subscription`,
         {
           withCredentials: true,
         },
         {
           email: email,
           subscriptionId: stripeId,
           plan: "professional_yearly",
         }
       )
       .then((response) => {
         setLoadingPro(false);
         if (response.status !== 200) {
           throw new Error("error");
         }
         if (response.data.success === false) {
           setErrorMessage(response.data.message);
         } else {
           window.location.replace(response.data.url);
           setSuccessMessage("Successfully upgraded subscription!");
           localStorage.setItem("subscription", "pro");
         }
       })
       .catch((error) => {
         setLoadingPrm(false);
         setErrorMessage("There was an issue subscribing. Please contact us!");
       });
   };
 
   const handleSubscribeProYearly = () => {
     setLoadingPrm(true);
     fetchAPI
       .post(
         `${config.urlPlatform}/api/v2/payment/subscription`,
         {
           withCredentials: true,
         },
         {
           email: email,
           subscriptionId: stripeId,
           plan: "proMonth_yearly",
         }
       )
       .then((response) => {
         setLoadingPrm(false);
         if (response.status !== 200) {
           throw new Error("error");
         }
         if (response.data.success === false) {
           setErrorMessage(response.data.message);
         } else {
           window.location.replace(response.data.url);
           setSuccessMessage("Successfully upgraded subscription!");
           localStorage.setItem("subscription", "pro");
         }
       })
       .catch((error) => {
         setLoadingPro(false);
         setErrorMessage("There was an issue subscribing. Please contact us!");
       });
   };

   const handleToggleChange = () => {
    setIsChecked(!isChecked);
  };


  
    const handleToggleChangeCRM = () => {
      setIsCheckedCRM(!isCheckedCRM);
      fetchAPI.post(`${config.urlPlatform}/api/v2/linkedinEngage/linkedInLeadCRM`, {
        withCredentials: true
      }, {
        "linkedInLeadCRM" : !isCheckedCRM
      })
    };

  const toggleHandler = () => {
    setIsToggleVisible(!isToggleVisible);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsToggleVisible(false);
      } else {
        setIsToggleVisible(true);
      }
    };

    // Initial check on mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [showLabel, setShowLabel] = useState(false);
  const ref = useRef(null);

  const handleClick = () => {
    setShowLabel(true);
  };

  // Detect clicks outside this component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowLabel(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [activeOption, setActiveOption] = useState(null);
  const containerRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setActiveOption(null); // Hide all on outside click
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const options = [
    { label: "AI Options", icon: icon1 },
    { label: "Notes Option", icon: icon2 },
    { label: "Message Center", icon: icon4 },
    { label: "Automation", icon: icon3 },
    { label: "Connection Requests", icon: icon5 },
];

useEffect(()=>{
  getLogsData();
  getLeadsData();
}, [])

const  getLogsData = async () => {
  await fetchAPI.get(`${config.urlPlatform}/api/v2/linkedinEngage/getLogs`, {
    withCredentials: true
}).then((response)=> {
    if(response?.status === 200) {
      setLogsData(response?.data)
    }
  }).catch((error) => {
    console.log(error);
  })
}

const getLeadsData = async () => {
  await fetchAPI.get(`${config.urlPlatform}/api/v2/linkedinEngage/getLeads`, {
    withCredentials: true
}).then((response)=> {
    if(response?.status === 200) {
      setLeadsData(response?.data?.data)
    }
  }).catch((error) => {
    console.log(error);
  })
}

const handleChange = (e, userName, inputField) => {
  const updatedData = JSON.parse(JSON.stringify(leadsData));
  const newNoteValue = e.target.value;

  updatedData.data.forEach((section) => {
    let connectionValue;
    
    if (section.userName === userName) {
      connectionValue = section;
    }
    if (connectionValue) {
      connectionValue[inputField] = newNoteValue;
    }
  });

  setLeadsData(updatedData);

  if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
  }

  debounceTimer.current = setTimeout(() => {
      saveNoteHandler(userName, updatedData);
  }, 1000);

};

const saveNoteHandler = (userName, updatedData) => {
  const updatedLeadsRow = updatedData?.data?.find(item => item?.userName === userName);

  const body = {
    "connectionRequestSent" : updatedLeadsRow?.connectionRequestSent || "",
    "notes" : updatedLeadsRow?.notes || "",
    "userName" : updatedLeadsRow?.userName
  }

  fetchAPI.post(`${config.urlPlatform}/api/v2/linkedinEngage/updateLead`, {
    withCredentials: true
  }, body)
}

  return (
    <Section id="tips">
       <Button onClick={toggleHandler} className="toggle-button">
        {/* Displaying different icons based on the toggle state */}
        {isToggleVisible ? (
         <span role="img" aria-label="Left Icon">
         &lt; {/* Unicode character for left arrow */}
       </span>
     ) : (
       <span role="img" aria-label="Right Icon">
         &gt; {/* Unicode character for right arrow */}
       </span>
        )}
      </Button>
      <Dashwrapdiv>
       
      {isToggleVisible && (
        <div className="toggled-content">
          <Dashleftsidebar>
            <Link href="/platform" style={{cursor:"pointer" , textAlign:"center"}}>
            <Dashlogoimg src={logodash} />
            </Link>
           
         
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                d="M2.39987 11.9998V2.8C2.39987 2.32261 2.58951 1.86477 2.92707 1.52721C3.26464 1.18964 3.72248 1 4.19986 1H16.4399C16.9173 1 17.3751 1.18964 17.7127 1.52721C18.0502 1.86477 18.2399 2.32261 18.2399 2.8V11.9998M2.39987 11.9998H18.2399M2.39987 11.9998L1.06787 16.7104C0.992214 16.978 0.979614 17.2596 1.03105 17.5329C1.08249 17.8062 1.19658 18.0639 1.36435 18.2858C1.53212 18.5076 1.74901 18.6875 1.99801 18.8115C2.24701 18.9354 2.52133 18.9999 2.79947 19H17.8403C18.1184 18.9999 18.3927 18.9354 18.6417 18.8115C18.8907 18.6875 19.1076 18.5076 19.2754 18.2858C19.4432 18.0639 19.5572 17.8062 19.6087 17.5329C19.6601 17.2596 19.6475 16.978 19.5719 16.7104L18.2399 11.9998"
                stroke="#0050B2"
                strokeWidth="1.125"
              />
              <path
                d="M9.42021 16.3H11.2202M12.1202 4.59998L13.9202 6.39998L12.1202 8.19998M8.52021 4.59998L6.72021 6.39998L8.52021 8.19998"
                stroke="#0050B2"
                strokeWidth="1.125"
                strokeLinecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Leads
          </span>
          <diRev ref={containerRef} style={{display:"flex" , flexDirection:"column"}}>
            {options.map((opt) => (
              <p
                key={opt.label}
                onClick={() => setActiveOption(opt.label)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  userSelect: "none",
                  marginBottom: "18px",
                  marginTop: "18px",
                  paddingLeft:"15px",
                  postion:"relative",
                  width:" max-content",
                  position:"relative",
                }}
              >
                <img src={opt.icon} alt="icon" style={{ width: "20px", height: "20px" }} />
                <span>{opt.label}</span>
                {activeOption === opt.label && (
                  <span style={{ color: "#fff", fontSize: "12px" , position:"absolute"  , color:"#0050b2" , background:"#fff" , padding:"2px" ,   top: "-17px" , right: "-47px" }}>Coming soon</span>
                )}
              </p>
            ))}
          </diRev>
    
        
          <div>
            <p style={{cursor:"pointer"}} onClick={handleClicklink}>
              
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
              >
                <path
                  d="M10.9859 0.00625031C10.2854 0.0505964 9.62294 0.315977 9.11007 0.757685C8.59721 1.19939 8.26527 1.79044 8.17019 2.43125L8.16069 2.5H4.75204L4.55528 2.50875C4.05164 2.55381 3.58429 2.77006 3.24435 3.11533C2.90441 3.4606 2.71627 3.91013 2.71661 4.37625L2.7139 7.20625L2.63655 7.21375C1.9054 7.30652 1.23548 7.64012 0.750756 8.15282C0.266035 8.66552 -0.000668728 9.32262 1.25924e-06 10.0025L0.00678616 10.195C0.0549265 10.8402 0.343012 11.4505 0.822513 11.9229C1.30201 12.3954 1.94363 12.7012 2.63927 12.7887L2.71526 12.795V15.6275L2.72611 15.8075C2.775 16.2712 3.00956 16.7016 3.38409 17.0147C3.75861 17.3278 4.24627 17.5013 4.75204 17.5012H7.48493L7.49307 17.57C7.59344 18.2435 7.95526 18.8608 8.51158 19.3075C9.06789 19.7543 9.78104 20.0003 10.5191 20L10.728 19.9938C11.4285 19.9494 12.091 19.684 12.6038 19.2423C13.1167 18.8006 13.4486 18.2096 13.5437 17.5688L13.5505 17.5012H16.9646C17.5044 17.5012 18.0221 17.3037 18.4038 16.9521C18.7856 16.6004 19 16.1235 19 15.6263L18.9973 11.5625L16.6213 11.5638L16.4544 11.5575C16.0347 11.5201 15.6454 11.3396 15.3628 11.0515C15.0801 10.7634 14.9245 10.3884 14.9264 10L14.9332 9.84625C14.9735 9.45969 15.1691 9.10092 15.4816 8.84031C15.7941 8.5797 16.2011 8.43604 16.6226 8.4375L18.9973 8.43625L19 4.3775L18.9905 4.19625C18.9419 3.7323 18.7075 3.30165 18.3329 2.98827C17.9584 2.6749 17.4706 2.50127 16.9646 2.50125H14.2276L14.2208 2.43125C14.1208 1.75748 13.7591 1.13993 13.2027 0.692937C12.6464 0.245939 11.9331 -0.000231973 11.1948 1.64028e-07L10.9859 0.00625031ZM11.1948 1.25C12.1311 1.25 12.891 1.95 12.891 2.8125V3.75L16.9646 3.7525L17.0867 3.7625C17.2429 3.78883 17.3841 3.8648 17.4858 3.97718C17.5875 4.08955 17.6431 4.23122 17.6431 4.3775L17.6403 7.18625L16.6213 7.1875C15.8546 7.18733 15.116 7.45286 14.5521 7.93132C13.9882 8.40977 13.6403 9.06614 13.5776 9.77L13.5695 9.975C13.5695 11.4675 14.7935 12.685 16.3729 12.8038L16.5955 12.8125L17.6417 12.81V15.6275C17.6417 15.7933 17.5702 15.9522 17.443 16.0694C17.3157 16.1867 17.1432 16.2525 16.9632 16.2525L12.2125 16.25L12.2153 17.1875C12.2151 17.6019 12.0362 17.9993 11.718 18.2922C11.3997 18.5851 10.9682 18.7495 10.5184 18.7494C10.0685 18.7492 9.63717 18.5844 9.3192 18.2913C9.00123 17.9981 8.8227 17.6007 8.82288 17.1862L8.81881 16.25L4.75204 16.2525C4.57209 16.2525 4.39952 16.1867 4.27228 16.0694C4.14504 15.9522 4.07356 15.7933 4.07356 15.6275L4.07085 11.5625L3.05042 11.565C2.82768 11.5649 2.60713 11.5244 2.40137 11.4458C2.19562 11.3672 2.00868 11.2521 1.85124 11.1069C1.69379 10.9618 1.56893 10.7895 1.48377 10.5999C1.39861 10.4103 1.35483 10.2071 1.35491 10.0019C1.355 9.79668 1.39897 9.59352 1.48429 9.40398C1.56961 9.21444 1.69463 9.04224 1.8522 8.8972C2.17042 8.60429 2.60192 8.43983 3.05178 8.44L4.07085 8.4375L4.07356 4.3775C4.07356 4.21174 4.14504 4.05277 4.27228 3.93556C4.39952 3.81835 4.57209 3.7525 4.75204 3.7525L9.49864 3.75V2.8125C9.49864 1.95 10.2585 1.25 11.1948 1.25Z"
                  fill="white"
                />
              </svg>
              Download Chrome <br /> Extension
            </p>
            <p style={{cursor:"pointer"}} onClick={handleClicksupprt}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
              >
                <path
                  d="M8.77 16V15H15.385C15.5517 15 15.6957 14.9487 15.817 14.846C15.939 14.7433 16 14.6087 16 14.442V7.554C16 5.68067 15.3113 4.11633 13.934 2.861C12.556 1.605 10.9113 0.977 9 0.977C7.08867 0.977 5.444 1.60467 4.066 2.86C2.68867 4.116 2 5.68067 2 7.554V13.231H1.5C1.09133 13.231 0.739 13.0927 0.443 12.816C0.147667 12.54 0 12.1973 0 11.788V9.904C0 9.60533 0.0969999 9.34033 0.291 9.109C0.485667 8.87767 0.722 8.68933 1 8.544L1.017 7.315C1.04767 6.27167 1.284 5.305 1.726 4.415C2.16733 3.52567 2.74867 2.75133 3.47 2.092C4.19133 1.43333 5.02933 0.92 5.984 0.552C6.938 0.184 7.94333 0 9 0C10.0567 0 11.061 0.184 12.013 0.552C12.9663 0.92 13.8043 1.43233 14.527 2.089C15.2497 2.74567 15.831 3.519 16.271 4.409C16.711 5.299 16.9483 6.26567 16.983 7.309L17 8.514C17.2653 8.63867 17.4983 8.806 17.699 9.016C17.8997 9.22667 18 9.47933 18 9.774V11.939C18 12.2343 17.8997 12.487 17.699 12.697C17.499 12.9077 17.266 13.075 17 13.199V14.443C17 14.8777 16.8427 15.246 16.528 15.548C16.2133 15.85 15.8323 16.001 15.385 16.001L8.77 16ZM6.385 9.538C6.17833 9.538 5.99833 9.468 5.845 9.328C5.69167 9.188 5.615 9.01467 5.615 8.808C5.615 8.60133 5.69167 8.42467 5.845 8.278C5.99833 8.13133 6.17833 8.058 6.385 8.058C6.59167 8.058 6.77133 8.13133 6.924 8.278C7.07733 8.42467 7.154 8.60133 7.154 8.808C7.154 9.01467 7.07733 9.188 6.924 9.328C6.77067 9.468 6.59067 9.538 6.384 9.538M11.615 9.538C11.4083 9.538 11.2287 9.468 11.076 9.328C10.9227 9.188 10.846 9.01467 10.846 8.808C10.846 8.60133 10.9227 8.42467 11.076 8.278C11.2293 8.13133 11.4093 8.058 11.616 8.058C11.822 8.058 12.0017 8.13133 12.155 8.278C12.3083 8.42467 12.385 8.60133 12.385 8.808C12.385 9.01467 12.3083 9.188 12.155 9.328C12.0017 9.468 11.8217 9.538 11.615 9.538ZM3.717 7.95C3.62633 6.45267 4.10833 5.17633 5.163 4.121C6.21833 3.06567 7.514 2.538 9.05 2.538C10.3413 2.538 11.4853 2.92567 12.482 3.701C13.4787 4.47567 14.0873 5.494 14.308 6.756C12.9833 6.73933 11.754 6.40133 10.62 5.742C9.48667 5.08333 8.61667 4.16667 8.01 2.992C7.76867 4.146 7.267 5.15733 6.505 6.026C5.743 6.89467 4.81367 7.536 3.717 7.95Z"
                  fill="white"
                />
              </svg>
              Support
            </p>
            <p style={{cursor:"pointer"}} onClick={handleClicksetting}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M19.7359 13.1693L18.1915 11.8567C18.2646 11.4113 18.3023 10.9566 18.3023 10.5019C18.3023 10.0472 18.2646 9.59246 18.1915 9.14712L19.7359 7.83453C19.8524 7.7354 19.9358 7.60336 19.9749 7.45598C20.0141 7.3086 20.0072 7.15286 19.9552 7.00947L19.934 6.94853C19.5088 5.76726 18.8721 4.6722 18.0547 3.71627L18.0123 3.66705C17.9131 3.55115 17.7809 3.46783 17.6332 3.42808C17.4854 3.38833 17.3291 3.39402 17.1846 3.44438L15.2676 4.12177C14.5602 3.54517 13.7703 3.09045 12.9168 2.77168L12.5466 0.779351C12.5186 0.629439 12.4455 0.491524 12.3368 0.383928C12.2282 0.276331 12.0891 0.204147 11.9382 0.176965L11.8746 0.165246C10.6461 -0.0550819 9.35393 -0.0550819 8.12544 0.165246L8.06178 0.176965C7.91086 0.204147 7.77184 0.276331 7.66318 0.383928C7.55452 0.491524 7.48136 0.629439 7.45343 0.779351L7.08088 2.78105C6.23412 3.09989 5.44557 3.55437 4.74652 4.12646L2.81538 3.44438C2.67099 3.39362 2.51448 3.38773 2.36665 3.4275C2.21882 3.46728 2.08666 3.55083 1.98774 3.66705L1.9453 3.71627C1.12886 4.67288 0.492285 5.76775 0.0660269 6.94853L0.0448055 7.00947C-0.0613015 7.30246 0.0259421 7.63061 0.264093 7.83453L1.8274 9.16118C1.75431 9.60184 1.71894 10.0519 1.71894 10.4996C1.71894 10.9496 1.75431 11.3996 1.8274 11.8379L0.264093 13.1646C0.147601 13.2637 0.0642265 13.3958 0.0250554 13.5431C-0.0141157 13.6905 -0.00722707 13.8463 0.0448055 13.9896L0.0660269 14.0506C0.492813 15.2319 1.12474 16.3218 1.9453 17.2828L1.98774 17.3321C2.0869 17.448 2.21906 17.5313 2.36681 17.571C2.51455 17.6108 2.67095 17.6051 2.81538 17.5547L4.74652 16.8727C5.44919 17.4469 6.23438 17.9016 7.08088 18.2181L7.45343 20.2198C7.48136 20.3697 7.55452 20.5076 7.66318 20.6152C7.77184 20.7228 7.91086 20.795 8.06178 20.8221L8.12544 20.8339C9.36521 21.0554 10.6348 21.0554 11.8746 20.8339L11.9382 20.8221C12.0891 20.795 12.2282 20.7228 12.3368 20.6152C12.4455 20.5076 12.5186 20.3697 12.5466 20.2198L12.9168 18.2274C13.77 17.9095 14.5644 17.4533 15.2676 16.8773L17.1846 17.5547C17.329 17.6055 17.4855 17.6114 17.6333 17.5716C17.7812 17.5318 17.9133 17.4483 18.0123 17.3321L18.0547 17.2828C18.8753 16.3195 19.5072 15.2319 19.934 14.0506L19.9552 13.9896C20.0613 13.7013 19.9741 13.3732 19.7359 13.1693ZM16.5173 9.4237C16.5763 9.77763 16.6069 10.1409 16.6069 10.5042C16.6069 10.8675 16.5763 11.2309 16.5173 11.5848L16.3617 12.5247L18.1231 14.0225C17.8561 14.634 17.519 15.2128 17.1186 15.7476L14.9304 14.9764L14.19 15.5812C13.6265 16.0406 12.9993 16.4015 12.3202 16.6547L11.4218 16.9899L10.9998 19.2634C10.3338 19.3385 9.66147 19.3385 8.99552 19.2634L8.57345 16.9852L7.68215 16.6453C7.01014 16.3922 6.38529 16.0312 5.82646 15.5741L5.08607 14.9671L2.88376 15.7452C2.48291 15.2085 2.14808 14.6295 1.87928 14.0201L3.65952 12.5083L3.50625 11.5707C3.44966 11.2215 3.41901 10.8605 3.41901 10.5042C3.41901 10.1456 3.4473 9.78701 3.50625 9.43776L3.65952 8.5002L1.87928 6.98838C2.14572 6.37661 2.48291 5.80001 2.88376 5.26326L5.08607 6.04143L5.82646 5.43436C6.38529 4.9773 7.01014 4.61634 7.68215 4.36319L8.57581 4.02801L8.99788 1.74973C9.66046 1.67473 10.3372 1.67473 11.0021 1.74973L11.4242 4.02333L12.3226 4.35851C12.9993 4.61165 13.6289 4.97261 14.1924 5.43202L14.9328 6.03675L17.121 5.2656C17.5218 5.80236 17.8566 6.3813 18.1254 6.99072L16.3641 8.48848L16.5173 9.4237ZM10.0024 6.14457C7.71045 6.14457 5.8524 7.99157 5.8524 10.2699C5.8524 12.5481 7.71045 14.3951 10.0024 14.3951C12.2943 14.3951 14.1523 12.5481 14.1523 10.2699C14.1523 7.99157 12.2943 6.14457 10.0024 6.14457ZM11.8698 12.1262C11.6249 12.3704 11.3338 12.564 11.0133 12.696C10.6928 12.8279 10.3492 12.8956 10.0024 12.895C9.29734 12.895 8.63476 12.6208 8.13487 12.1262C7.88923 11.8828 7.69444 11.5934 7.56171 11.2748C7.42898 10.9562 7.36093 10.6147 7.36147 10.2699C7.36147 9.56902 7.63735 8.91038 8.13487 8.41347C8.63476 7.91656 9.29734 7.64467 10.0024 7.64467C10.7074 7.64467 11.37 7.91656 11.8698 8.41347C12.1155 8.65696 12.3103 8.94631 12.443 9.2649C12.5757 9.58349 12.6438 9.92502 12.6432 10.2699C12.6432 10.9707 12.3674 11.6293 11.8698 12.1262Z"
                  fill="white"
                />
              </svg>
              Settings
            </p>
         
            <UpgradeButton>
              <button type="button" onClick={openPlanModal}>Upgrade Plan</button>
            </UpgradeButton>
              {(storage?.plan === 'starter' || storage?.plan === 'professional' || storage?.plan === 'starter_yearly' || storage?.plan === 'professional_yearly') && storage?.paidStatus}
                    {isPlanModalOpen && (
                      <div className="modalOverlay" onClick={closePlanModal}>
                        <div
                          className="modalContent"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="modalHeader">
                            <span
                              className="closeButton"
                              onClick={closePlanModal}
                            >
                              &times;
                            </span>
                          </div>
                          <div className="planInnermodal">
                          <Toggle>
                            <div className="toggle-container">
                                      <label className="toggle-label">Monthly</label>
                                        <label className="toggle">
                                          <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleToggleChange}
                                          />
                                          <span className="slider"></span>
                                        </label>
                                        <label className="toggle-label">Yearly (up to 30% OFF)</label>
                            </div>
                          </Toggle>
                         {isChecked ? (
                                <>
                                <div className="planWrapperDiv">
                            {(
                              (userDetail?.plan === "starter_yearly" && userDetail?.paidStatus !== true) || 
                              userDetail.status === "canceled" || 
                              ["starter", "professional", "proMonth"].includes(userDetail?.plan) && userDetail?.paidStatus
                            )  && (
                              <PlanboxOne>
                                <FreeplanPart>
                                  <h2>Starter plans</h2>
                                </FreeplanPart>
                                <ContentList>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text> 300 comments/month</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>1 emotion</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>TextTune™ - only short comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>GenuYou™ - turn your ideas into comments </Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Multi-language support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Grammar check of your comment</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Standard support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Commenter academy</Text>
                                  </ContentItem>
                                  <MonthPlan>
                                    {" "}
                                    <span>$144</span> $97/year
                                  </MonthPlan>
                                  <BoxContent isButton>
                                    <SubmitButton
                                      className={
                                        isLoadingThree ? "loading" : ""
                                      }
                                      onClick={handleSubscribeYearly}
                                    >
                                      {isLoadingThree ? (
                                        <Loader />
                                      ) : (
                                        "UPGRADE ME TO STARTER"
                                      )}
                                    </SubmitButton>
                                  </BoxContent>
                                
                                </ContentList>
                              </PlanboxOne>
                            )}
            
                            <PlanboxTwo>
                              <ProPlan>Influencer PLAN
                                <span>(customize your prompt)</span>
                              </ProPlan>
                              {/* <Tag>Most Popular</Tag> */}
            
                              <ContentList>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>3000 comments/month </Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>5 emotions (+Natural™ emotion)</Text>
                                </ContentItem>
                                
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Full TextTune™ - short & long comments</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>GenuYou™ - turn your ideas into comments</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Multi-language support</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Grammar check of your comment</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>VIP support</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Commenter academy</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>SmartReply+™ - reply to comments</Text>
                                </ContentItem>
                              
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Video course: "Strategic commenting"</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>
                                    <strong>+Customize your prompt & voice</strong>
                                  </Text>
                                </ContentItem>
                                <ContentItem>
                      <CheckIcon src={checkIcon} />
                      <Text>
                        <strong>+Posts feature - personalized newsfeed</strong>
                      </Text>
                    </ContentItem>
                               
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Saved comments - unlimited</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Engagement list - unlimited</strong></Text>
                                </ContentItem>
                                <ContentItem>
                          <CheckIcon src={checkIcon} />
                          <Text>
                            <strong>+13 commenting styles</strong>
                          </Text>
                        </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Commenting on Facebook and Twitter</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+eBook - "All-in-one LI personal branding"</strong></Text>
                                </ContentItem>
                                <MonthPlan>
                                  {" "}
                                  <span>$324</span> $197/year
                                </MonthPlan>
                                <PerCup>
                                  (less than a cup of coffee per day)
                                </PerCup>
                                <BoxContent isButton>
                                  <SubmitButton
                                    className={isLoadingPrm ? "loading" : ""}
                                    onClick={handleSubscribeProYearly}
                                  >
                                    {isLoadingPrm ? (
                                      <Loader />
                                    ) : (
                                      "UPGRADE ME TO INFLUENCER"
                                    )}
                                  </SubmitButton>
                                </BoxContent>
                                {/* <RedButtonclick>
                                              <RedLinkButton
                                                href={urlPaths.proplan}
                                                text="UPGRADE PREMIUM PLAN"
                                                rounded={false}
                                              />
                                            </RedButtonclick> */}
                                <CancleAnytime>
                                  {/* <TextCancel>
                                                <CheckIcon
                                                  style={{ width: "13px", height: "13px" }}
                                                  src={checkIcon}
                                                />
                                                <Text>No credit card required</Text>
                                              </TextCancel> */}
                                </CancleAnytime>
                              </ContentList>
                            </PlanboxTwo>
            
                            {showProfessionalBannerYearly && (
                              <PlanboxOne>
                                <ProPlanBlackTwo>
                                  Creator PLAN
                                </ProPlanBlackTwo>
                                <ContentList>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>900 comments/month </Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>3 emotions</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text> Full TextTune™ - short and long comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>GenuYou™ - turn your ideas into comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Multi-language support.</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Grammar check of your comment</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Priority support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Commenter academy</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+SmartReply+™- basic comment replies</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+5 commenting styles</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Saved comments - up to 40.</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Engagement list - up to 40.</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Video course: “Strategic commenting”</strong></Text>
                                  </ContentItem>
                                  <MonthPlan>
                                    {" "}
                                    <span>$204</span> $149/year
                                  </MonthPlan>
            
                                  {/* <MonthPlan> <span>$324</span> $243/year</MonthPlan> */}
                                  <NewRedbtn>
                                    <BoxContent isButton>
                                      <SubmitButton
                                        className={
                                          isLoadingPro ? "loading" : ""
                                        }
                                        onClick={handleSubscribeProfesYearly}
                                      >
                                        {isLoadingPro ? (
                                          <Loader />
                                        ) : (
                                          "UPGRADE ME TO CREATOR"
                                        )}
                                      </SubmitButton>
                                    </BoxContent>
                                    {/* <RedButtonclick>
                                                  <RedLinkButton
                                                    href="https://forms.gle/LkJZVf9eNju6s7C27"
                                                    text="UPGRADE PROFESSIONAL PLAN"
                                                    rounded={false}
                                                  />
                                                </RedButtonclick> */}
                                    {/* <CancleAnytime>
                                                  <TextCancel>
                                                    <CheckIcon
                                                      style={{
                                                        width: "13px",
                                                        height: "13px",
                                                      }}
                                                      src={checkIcon}
                                                    />
                                                    <Text>Limited spots available</Text>
                                                  </TextCancel>
                                                </CancleAnytime> */}
                                  </NewRedbtn>
                                </ContentList>
                              </PlanboxOne>
                            )}
                                </div>
                                </>
                                ):(<>
                                <div className="planWrapperDiv">
                                
                            {(
                              (userDetail?.plan === "starter" && userDetail?.paidStatus !== true) || 
                              userDetail.status === "canceled" || 
                              ["starter_yearly", "professional_yearly", "proMonth_yearly"].includes(userDetail?.plan) && userDetail?.paidStatus
                            ) &&  (
                              <PlanboxOne>
                                <FreeplanPart>
                                  <h2>Starter plans</h2>
                                </FreeplanPart>
                                <ContentList>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>300 comments/month</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>1 emotion</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>TextTune™ - only short comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>GenuYou™ - turn your ideas into comments </Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Multi-language support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Grammar check of your comment</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Standard support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Commenter academy</Text>
                                  </ContentItem>
                                  <MonthPlan>
                                    {" "}
                                    <span></span>Just $12/month
                                  </MonthPlan>
                                  <BoxContent isButton>
                                    <SubmitButton
                                      className={
                                        isLoadingThree ? "loading" : ""
                                      }
                                      onClick={handleSubscribe}
                                    >
                                      {isLoadingThree ? (
                                        <Loader />
                                      ) : (
                                        "UPGRADE ME TO STARTER"
                                      )}
                                    </SubmitButton>
                                  </BoxContent>
                                  {/* <RedButtonclick>
                                              <RedLinkButton
                                                href={urlPaths.register}
                                                text="Upgrade Plan"
                                                rounded={false}
                                              />
                                            </RedButtonclick> */}
                                  {/* <NeeDed>
                                                <CheckIcon
                                                  style={{ width: "13px", height: "13px" }}
                                                  src={checkIcon}
                                                />
                                                No credit card required
                                              </NeeDed> */}
                                </ContentList>
                              </PlanboxOne>
                            )}
            
                            <PlanboxTwo>
                              <ProPlan>Influencer PLAN
                                <span>(customize your prompt)</span>
                              </ProPlan>
                              {/* <Tag>Most Popular</Tag> */}
            
                              <ContentList>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>3000 comments/month </Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>5 emotions (+Natural™ emotion)</Text>
                                </ContentItem>
                                {/* <ContentItem>
                            <CheckIcon src={checkIcon} />
                            <Text>10 commenting styles</Text>
                          </ContentItem> */}
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Full TextTune™ - short & long comments</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>GenuYou™ - turn your ideas into comments</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Multi-language support</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Grammar check of your comment</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>VIP support</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Commenter academy</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>SmartReply+™ - reply to comments</Text>
                                </ContentItem>
                                {/* <ContentItem>
                            <CheckIcon src={checkIcon} />
                            <Text>Access to our exclusive community</Text>
                          </ContentItem> */}
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>Video course: "Strategic commenting"</Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text>
                                    <strong>+Customize your prompt & voice</strong>
                                  </Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+13 commenting styles</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Saved comments - unlimited</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Engagement list - unlimited</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Special discounts for events, courses</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+Commenting on Facebook and Twitter</strong></Text>
                                </ContentItem>
                                <ContentItem>
                                  <CheckIcon src={checkIcon} />
                                  <Text><strong>+eBook - "All-in-one LI personal branding"</strong></Text>
                                </ContentItem>
                                <MonthPlan>
                                  {" "}
                                  <span>$81</span> $27/month
                                </MonthPlan>
                                <PerCup>
                                  (less than a cup of coffee per day)
                                </PerCup>
                                <BoxContent isButton>
                                  <SubmitButton
                                    className={isLoadingPrm ? "loading" : ""}
                                    onClick={handleSubscribePrm}
                                  >
                                    {isLoadingPrm ? (
                                      <Loader />
                                    ) : (
                                      "UPGRADE ME TO INFLUENCER"
                                    )}
                                  </SubmitButton>
                                </BoxContent>
                                {/* <RedButtonclick>
                                              <RedLinkButton
                                                href={urlPaths.proplan}
                                                text="UPGRADE PREMIUM PLAN"
                                                rounded={false}
                                              />
                                            </RedButtonclick> */}
                                <CancleAnytime>
                                  {/* <TextCancel>
                                                <CheckIcon
                                                  style={{ width: "13px", height: "13px" }}
                                                  src={checkIcon}
                                                />
                                                <Text>No credit card required</Text>
                                              </TextCancel> */}
                                </CancleAnytime>
                              </ContentList>
                            </PlanboxTwo>
            
                            {showProfessionalBanner && (
                              <PlanboxOne>
                                <ProPlanBlackTwo>
                                  Creator PLAN
                                </ProPlanBlackTwo>
                                <ContentList>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>900 comments/month </Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>3 emotions</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text> Full TextTune™ - short and long comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>GenuYou™ - turn your ideas into comments</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Multi-language support.</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Grammar check of your comment</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Priority support</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text>Commenter academy</Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+SmartReply+™- basic comment replies</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+5 commenting styles</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Saved comments - up to 40.</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Engagement list - up to 40.</strong></Text>
                                  </ContentItem>
                                  <ContentItem>
                                    <CheckIcon src={checkIcon} />
                                    <Text><strong>+Video course: “Strategic commenting”</strong></Text>
                                  </ContentItem>
                                  <MonthPlan>
                                    {" "}
                                    <span>$36</span> $17/month
                                  </MonthPlan>
            
                                  {/* <MonthPlan> <span>$324</span> $243/year</MonthPlan> */}
                                  <NewRedbtn>
                                    <BoxContent isButton>
                                      <SubmitButton
                                        className={
                                          isLoadingPro ? "loading" : ""
                                        }
                                        onClick={handleSubscribePro}
                                      >
                                        {isLoadingPro ? (
                                          <Loader />
                                        ) : (
                                          "UPGRADE ME TO CREATOR"
                                        )}
                                      </SubmitButton>
                                    </BoxContent>
                                    {/* <RedButtonclick>
                                                  <RedLinkButton
                                                    href="https://forms.gle/LkJZVf9eNju6s7C27"
                                                    text="UPGRADE PROFESSIONAL PLAN"
                                                    rounded={false}
                                                  />
                                                </RedButtonclick> */}
                                    {/* <CancleAnytime>
                                                  <TextCancel>
                                                    <CheckIcon
                                                      style={{
                                                        width: "13px",
                                                        height: "13px",
                                                      }}
                                                      src={checkIcon}
                                                    />
                                                    <Text>Limited spots available</Text>
                                                  </TextCancel>
                                                </CancleAnytime> */}
                                  </NewRedbtn>
                                </ContentList>
                              </PlanboxOne>
                            )}
                                </div>
                                </>)}
                        </div>        
                        </div>
                      </div>
                    )}
                    <style jsx>{`
                                  .modalOverlay {
                                      position: fixed;
                                      top: 0;
                                      left: 0;
                                      width: 100%;
                                      height: 100%;
                                      background: rgba(0, 0, 0, 0.8);
                                      display: flex;
                                      align-items: start;
                                      justify-content: center;
                                      z-index: 99;
                                      {/* padding-top: 40px; */}
                                  }
            
                                          .modalContent {
                                              background: #fff0;
                                                  padding: 20px;
                                                  border-radius: 8px;
                                                  width: 100%;
                                                  /* margin: 40px auto; */
                                                  height: calc(100vh - 35px);
                                                  overflow-y: auto;
                                          }
            
                                          .modalHeader {
                                          display: flex;
                                          justify-content: flex-end;
                                          }
            
                                          .closeButton {
                                          cursor: pointer;
                                          font-size: 30px;
                                          color: #fff;
                                          }
            
                                          .openButton {
                                          margin-top: 20px;
                                          cursor: pointer;
                                          }
                                          .planWrapperDiv{
                                              display:flex;
                                              justify-content: center;
                                              gap: 10px;
                                              margin-top: 50px;
                                          }
                                          ::-webkit-scrollbar {
                                           width: 0px;
                                            }
            
                                          .planInnermodal{
                                          position:relative;}
            
                                          @media only screen and (max-width:1023px){
                                              .planWrapperDiv {
                                                      flex-direction: column;
                                                  }
                                                  .planWrapperDiv >div {
                                                      width: 100%;
                                                      margin: auto;
                                                      max-width: 100%;
                                                      box-sizing:border-box;
                                                  }
                                          }
                                          }
            
                                          @media only screen and (max-width:767px){
                                              .modalContent {
                                                  height: 600px;
                                                }
                                          }
                                      `}</style>
          </div>
        </Dashleftsidebar>
        </div>
      )}

        
        <Dashrightcol>
          <Imagetopleft src={topleft} alt="img" />
          <Imagetopright src={topright} alt="img" />
          <Imagebottomleft src={bottomleft} alt="img" />
          <Imagebottomright src={bottomright} alt="img" />

          <DashTableWrapper>
            <Dashinnerwrap >
            <DashTabs>
              <button onClick={() => setActiveTab("tab1")} className={activeTab === "tab1" ? "active" : ""}>
              Your comment activity
              </button>
              <button onClick={() => setActiveTab("tab2")} className={activeTab === "tab2" ? "active" : ""}>
              Your leads
              </button>
            </DashTabs>
            <Toggle>
            <div className="toggle-container">
              <label className="toggle-label2">
                {isCheckedCRM ? 'On' : 'Off'}
              </label>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={isCheckedCRM}
                  onChange={handleToggleChangeCRM}
                />
                <span className="slider"></span>
              </label>
            </div>
          </Toggle>
            </Dashinnerwrap>

            {activeTab === "tab1" && (
              <TableContent className="tab-content" >
                 {logsData?.data?.data?.length > 0 ? <table style={{ width: "100%", marginTop: "1rem", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={tableHeaderStyle}>Name</th>
                      <th style={tableHeaderStyle}>User Profile</th>
                      <th style={tableHeaderStyle}>Post Url</th>
                      <th style={tableHeaderStyle}>Date Comment</th>
                      <th style={tableHeaderStyle}>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                      logsData?.data?.data?.map((items, index)=> {
                        return (
                          <tr key={`${items?.userName}-${index}`}>
                            <td style={tableCellStyle}>{items?.fullName}</td>
                            <td style={tableCellStyle}>{items?.userProfile}</td>
                            <td style={tableCellStyle}>
                              <Link
                                style={{ cursor: "pointer" }}
                                href={items?.postUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {items?.postUrl}
                              </Link>
                            </td>
                            <td style={tableCellStyle}>{new Date(items.date._seconds * 1000).toLocaleString()}</td>
                            <td style={tableCellStyle}>{items?.comment}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody> 
                </table> : <div style={{ color: "black", fontSize: "20px", textAlign: "center" }}>No Record Found</div>}
              </TableContent>
            )}

            {activeTab === "tab2" && (
               <TableContent className="tab-content">
               {logsData?.data?.data?.length > 0 ? <table style={{ width: "100%", marginTop: "1rem", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>User Profile</th>
                    <th style={tableHeaderStyle}>Name</th>
                    <th style={tableHeaderStyle}>Comment Count</th>
                    <th style={tableHeaderStyle}>Lead Status</th>
                    <th style={tableHeaderStyle}>Connection Request Sent</th>
                    <th style={tableHeaderStyle}>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    leadsData?.data?.map((items, index)=> {
                      return (
                        <tr key={`${items?.userName}-${index}`}>
                          <td style={tableCellStyle}>
                              <Link
                                style={{ cursor: "pointer" }}
                                href={items?.userProfile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {items?.userProfile}
                              </Link>
                            </td>
                          <td style={tableCellStyle}>{items?.fullname}</td>
                          <td style={tableCellStyle}>{items?.commentCount}</td>
                          <td style={tableCellStyle}>{items?.status}</td>
                          <td style={tableCellStyle}><input className="form-control" onChange={(e)=>handleChange(e, items?.userName, "connectionRequestSent")} value={items?.connectionRequestSent || ""} /></td>
                          <td style={tableCellStyle}><textarea className="form-control" onChange={(e)=>handleChange(e, items?.userName, "notes")} value={items?.notes || ""} ></textarea></td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table> : <div style={{ color: "black", fontSize: "20px", textAlign: "center" }}>No Record Found</div>}
            </TableContent>
            )}
          </DashTableWrapper>
        

        </Dashrightcol>
      </Dashwrapdiv>
    </Section>
  );
};


const Section = styled.section`
  position: relative;
  display: flex;
  color: var(--white);
  min-height: 800px;
 @media only screen and (-webkit-min-device-pixel-ratio: 2) {
    min-height: 600px !important;
  }
  @media only screen and (max-width: ${size.maxWidthTablet}) {
   min-height: 100%;
  }
  @media only screen and (max-width: ${size.minWidthTablet}) {
    padding-top: 0;
  }
`;

const Ptag = styled.div`
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0px;
  padding-left: 15px;
  display: flex;
  gap: 20px;
  >svg {
    margin-top: 5px;
  }
}
`;
const Dashbutton = styled.div`
>button {
  color: var(--blue, #0050B2);
  text-align: center;
  font-family: Space Grotesk;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: 155.523%; /* 62.209px */
  text-transform: uppercase;
  width: 499px;
  height: 82px;
  flex-shrink: 0;
  border-radius: 260px;
  border: 3px solid var(--blue, #0050B2);
  background: rgba(12, 211, 255, 0.20);
  margin-top: 50px;
  @media only screen and (max-width:580px ) {
      width: 300px;
      height: 62px;
      font-size: 20px; }}
>p {
  color: var(--blue, #0050B2);
  text-align: center;
  font-family: Space Grotesk;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 155.523%; /* 55.988px */
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;}`;

const Dashwrapdiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  @media only screen and (max-width:1024px ) {
      position: relative;
  }`;
const Dngagementcenter = styled.div`
  position: absolute;
  width: 100%;
  max-width: 500px;
  margin: auto;
  height: max-content;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
>img {
  @media only screen and (max-width:991px ) {
    width: 190px;
    height: auto;}}`;

const Imagecomingsoon = styled.img`
width: 40px;`;
const ImageOptions = styled.img`
width: 20px;`;
const Imagedashlogo = styled.img``;
const Imagedashlogo2 = styled.img``;
const Dashrightcol = styled.div`
  position: relative;
  width: 100%;
  color#fff;
  overflow: auto;
  height: 100dvh;
  &::-webkit-scrollbar {
      width: 0px;
  }`;

const Dashleftsidebar = styled.div`
  position: relative;
  background: var(--blue, #0050B2);
  color#fff;
  width: 258px;
  height: 100%;
  flex-shrink: 0;
  padding: 10px 15px 15px 0px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  &::-webkit-scrollbar {
      width: 0px;}

@media only screen and (max-width:1024px ) {
  position: absolute;
  z-index:2;
  height: 100%;}
  >img {
      margin-bottom: 20px;
      margin-top: 20px;
    }
    >span {
      color: var(--blue, #0050B2);
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 27px */
      letter-spacing: -0.198px;
      width: 230px;
      height: 45px;
      flex-shrink: 0;
      border-radius: 0px 6px 6px 0px;
      background: var(--w, #FFF);
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      gap: 20px;
      padding-left: 15px;
      margin: 15px 0px;
    }
    >p {
      color: var(--w, #FFF);
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 27px */
      letter-spacing: -0.198px;
      display: flex;
      align-items: center;
      gap: 20px;
      padding-left: 15px; }
    >div {
      border-top: 1px solid #3570b9;
      margin-top: 100px;
     >p {
      color: var(--w, #FFF);
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 27px */
      letter-spacing: -0.198px;
      display: flex;
      gap: 20px;
      padding-left: 15px;

      >svg {
          margin-top: 5px;
      }}}
    `;
const UpgradeButton = styled.div`
  button {
    color: var(--white, var(--w, #fff));
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 200px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 5px;
    background: var(--blue, #007aff);
    margin-left: 15px;
    box-shadow: none;
    border: none;
    cursor: pointer;
    margin-bottom: 50px;
    margin-top: 20px;
  }
`;
const Imagetopleft = styled.img`
  position: absolute;
  top: 0;
  left: 0;

  @media only screen and (max-width:1300px ) {
    width: 300px;
    height: auto;
  }
  @media only screen and (max-width:991px ) {
    width: 200px;
    height: auto;
  }
@media only screen and (max-width:380px ) {
    width: 150px;
    height: auto;
}
`;
const Imagetopright = styled.img`
  position: absolute;
  top: 0;
  right: 0;

  @media only screen and (max-width:1300px ) {
    width: 300px;
    height: auto;
}
  @media only screen and (max-width:991px ) {
    width: 200px;
    height: auto;
}
@media only screen and (max-width:380px ) {
    width: 150px;
    height: auto;
}
`;
const Imagebottomleft = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;

  @media only screen and (max-width:1300px ) {
    width: 300px;
    height: auto;
}
  @media only screen and (max-width:991px ) {
    width: 200px;
    height: auto;
}
@media only screen and (max-width:380px ) {
    width: 150px;
    height: auto;
}
`;
const Imagebottomright = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;

  @media only screen and (max-width:1300px ) {
    width: 300px;
    height: auto;
}
  @media only screen and (max-width:991px ) {
    width: 200px;
    height: auto;
}
@media only screen and (max-width:380px ) {
    width: 150px;
    height: auto;
}
`;
const Dashlogoimg = styled.img`
  margin: auto;
  width: 138px;
  height: 96px;
  margin: auto;
  object-fit: contain;
  text-align: center;
`;
const DashTabs = styled.div`
  border: 1px solid rgb(0 0 0 / 6%);
  max-width: 650px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 0px;
  border-radius: 5px;
  width: 100%;
    @media only screen and (max-width:767px){
        height: 45px;
    }

  >button{
    width: 100%;
    height: 100%;
    background: none;
    border: 0px;
    font-size: 20px;
    font-weight: 400;
    cursor:pointer;
    @media only screen and (max-width:767px){
        font-size: 16px;
    }
    @media only screen and (max-width:480px){
        font-size: 12px;
        padding: 5px;
    }
       
        
    
    }
  .active {
    border-bottom: 3px solid rgb(0, 80, 178);
    background: rgb(209 231 249);
    color: rgb(0 80 178);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    font-weight:600;
}
`;
const DashTableWrapper = styled.div`
  position:relative;
  max-width:1400px;
  margin: auto;
  margin-top: 90px;
  padding:15px;`;

  const TableContent = styled.div`
  margin-top: 30px;
  overflow: auto;
  table-layout: fixed;
  height: 430px;
  ::-webkit-scrollbar {
  width: 10px!important;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

  @media only screen and (max-width: 767px) {
    margin-top: 0px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
     margin-top: 0px!important;
  }

  thead {
    border-radius: 5px 5px 0px 0px;
    background: rgb(5, 67, 142);
    position:sticky;
    top:0;

    th {
      padding: 10px;
      white-space: nowrap;  

      @media only screen and (max-width: 767px) {
        font-size: 16px !important;
      }
    }
  }

  tbody {
    background: #353535;

    td {
      padding: 15px;
      word-break: break-word;

      @media only screen and (max-width: 767px) {
        font-size: 16px !important;
      }
    }
  }
`;
const tableHeaderStyle = {
  border: "none",
  color: "rgb(255, 255, 255)",
  fontFamily: "Space Grotesk",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "normal",
  Padding:" 15px",
  textAlign: "start",
  border: "1px solid #ccc",
};

const tableCellStyle = {
  border: "1px solid #ccc",
  padding: "15px",  // allows wrapping
  wordWrap: "break-all",
};


const Button = styled.div``;
const Dashinnerwrap = styled.div`
  display:flex;
  justify-content:center;
  max-width:800px;
  margin:auto;
  gap:10px;
`;


const Toggle = styled.div`
    display: flex;
    width: content;
    margin: auto;
    justify-content: center;
   

@media only screen and (max-width:767px){
  padding:0px;
  display:flex;
  justify-content:center;
 
}
 .toggle-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
}

.toggle {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.toggle-label {
  font-size: 18px;
  font-weight: 600;
  color:#fff;


  @media only screen and (max-width:767px){
    font-size: 12px;
  }
}

.toggle-label2 {
  font-size: 18px;
  font-weight: 600;
  color:#000;


  @media only screen and (max-width:767px){
    font-size: 12px;
  }
}


`;


const direv = styled.div`
    display: flex;
    flex-direction: column;`;

    const PlanboxOne = styled.div`
    max-width: 389px;
    width: 100%;
    height: max-content;
    border-radius: 45px;
    border: 8px solid #ebebeb;
    background: var(--w, #fff);
    box-shadow: 0px 20px 56px 0px rgba(0, 0, 0, 0.16);
    @media only screen and (max-width: 991px) {
      max-width: 89%;
      margin: auto;
    }
    @media only screen and (max-width: 1322px) {
      width: 326px;
      flex-shrink: 0;
      ${"" /* box-sizing: border-box; */}
    }
  `;
  const FreeplanPart = styled.div`
    border-radius: 32px 32px 0px 0px;
    background: radial-gradient(
      142.67% 120.19% at 91.93% 3.53%,
      #d0e5ff 0%,
      #bfd3ec 0.01%,
      #dedede 48.92%,
      #dcecff 91.67%
    );
    & > h2 {
      color: #4b4b4b;
      font-family: Space Grotesk;
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
      /* padding: 41px 105px 55px 103px; */
      margin: 0px;
      text-align: center;
      min-height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `;
  
  const CheckIcon = styled.img`
    width: 14px !important;
    height: 14px !important;
  `;
  
  const ContentItem = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
  `;
  const ContentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    @media only screen and (max-width: 480px) {
      padding: 15px;
    }
  `;
  
  const Text = styled.div`
    font-family: Space Grotesk;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #12100b;
  `;
  
  const MonthPlan = styled.div`
    color: #000;
    font-family: Space Grotesk;
    font-size: 19.5px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    margin-top: 20px;
    text-align: center;
    > span {
      color: #000;
      text-align: center;
      font-family: Space Grotesk;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 30px */
      text-decoration-line: line-through;
    }
  `;
  
  const SubmitButton = styled.a`
    background: #ff2400;
    border-radius: 500px;
    padding: 16px 60px;
    color: #fff;
    font-family: "Space Grotesk", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 30px;
    outline: 6px solid rgba(255, 36, 0, 0.33);
    transition: 0.4s;
    text-transform: capitalize;
    min-width: 100px;
    display:inline-block;
    
    &.block {
      display: block;
      color: white;
    }
    &.cancel {
      background: transparent;
      color: #fff;
      outline: 6px solid rgba(255, 255, 255, 0.33);
      &.block {
        background: #0050b2;
        outline: 6px solid rgba(0, 36, 255, 0.33);
        &:hover {
          background-color: transparent;
        }
      }
    }
    &.loading {
      background-color: #fedd00;
      outline: 6px solid rgba(254, 221, 0, 0.42);
      transition: 0.4s;
      padding: 16px 60px;
    }
    &:hover {
      transition: 0.4s;
      background: var(--white);
      color: #ff2400;
      cursor: pointer;
    }
  
    span {
      display: inline-block;
    }
  
    @media only screen and (max-width: ${size.maxWidthTablet}) {
      padding: 12px 20px;
      text-align: center;
      outline: 3px solid rgba(255, 255, 255, 0.42);
      font-size: 16px;
      line-height: 25px;
    }
  `;
  
  const BoxContent = styled.p`
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 26px;
    text-align: ${(props) => (props.isButton ? "center" : "left")};
    margin-top: ${(props) => (props.isButton ? "15px" : "0")};
    &.block {
      margin-top: 0;
    }
    &.plan {
      font-size: 1.2rem;
    }
  `;
  
  const NeeDed = styled.div`
    color: #333;
    text-align: center;
    font-family: Space Grotesk;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 134.1%;
    letter-spacing: -0.8px;
    text-transform: capitalize;
    margin: 15px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  `;
  const PlanboxTwo = styled.div`
    border-radius: 45px;
    border: 8px solid #ebebeb;
    box-shadow: 0px 20px 56px 0px rgba(0, 0, 0, 0.16);
    max-width: 389px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: #fff;
    @media only screen and (max-width: 991px) {
      max-width: 89%;
      margin: auto;
    }
    @media only screen and (max-width: 1322px) {
      width: 306px;
      box-sizing: border-box;
    }
  `;
  const ProPlan = styled.div`
    border-radius: 40px 40px 0px 0px;
  
    background: radial-gradient(
      142.67% 120.19% at 91.93% 3.53%,
      #0050b2 0%,
      #2c281f 0.01%,
      #1f1b13 48.92%,
      #12100b 100%
    );
    height: 119px;
    color: var(--w, #fff);
    font-family: Space Grotesk;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    ${'' /* padding-right: 20px; */}
  
    >span{
    font-size: 16px;
    margin-top:4px;
    display:block;
  }
  `;
  
  const Tag = styled.div`
    background: #ff2400;
    padding: 6px;
    -webkit-transform: rotate(37deg);
    -ms-transform: rotate(37deg);
    -webkit-transform: rotate(37deg);
    -ms-transform: rotate(37deg);
    transform: rotate(37deg);
    position: absolute;
    top: 26px;
    width: 45%;
    right: -46px;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 100;
    line-height: normal;
    text-transform: uppercase;
    font-family: Space Grotesk;
    @media only screen and (max-width: 1323px) {
      top: 16px;
      width: 38%;
      right: -28px;
      font-size: 8px;
    }
    @media only screen and (max-width: 1200px) {
      position: absolute;
      top: 15px;
      width: 47%;
      right: -35px;
      text-align: center;
      font-size: 7px;
    }
    @media only screen and (max-width: 991px) {
      font-size: 13px;
      position: absolute;
      top: 30px;
      width: 200px;
      right: -46px;
      text-align: center;
    }
  
    @media only screen and (max-width: 480px) {
      font-size: 9px;
      top: 19px;
      width: 53%;
      text-align: center;
    }
  `;
  const PerCup = styled.div`
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  `;
  
  const CancleAnytime = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 18px;
  `;
  
  const TextCancel = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
  `;
  
  const ProPlanBlackTwo = styled.div`
    border-radius: 40px 40px 0px 0px;
    background: radial-gradient(
      96.02% 97.16% at 23.13% 29.46%,
      #0050b2 0%,
      #0a66c2 70.17%,
      #0050b2 100%
    );
    height: 119px;
    color: var(--w, #fff);
    font-family: Space Grotesk;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
  `;
  const NewRedbtn = styled.div`
    ${"" /* margin-top: 65px; */}
  
    @media only screen and (max-width: 767px) {
      margin-top: 0px;
    }
  `;
  
  
  




export default DashboardComingSoon;
